
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fairplay",
      function () {
        return require("private-next-pages/fairplay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fairplay"])
      });
    }
  